<template>
  <b-container fluid>
    <b-form @submit="onSearch" @reset="onReset">
      <b-row>
        <b-col sm="auto" md="auto" lg="auto">
          <b-form-group id="dateRangeInputGroup" label="Промежуток:" label-for="dateRange" description="Выберите промежуток дат для поиска.">
            <date-range-picker opens="right" :startDate="dateRange.startDate" :endDate="dateRange.endDate" :locale-data="dateRange.locale" :ranges="dateRange.ranges" @update="onDateRangeUpdate">
            </date-range-picker>
          </b-form-group>
        </b-col>

        <b-col sm="2" md="2">
          <b-form-group id="isOpenInputGroup" label="Открытые заявки?" label-for="isOpenInput" description="Отметьте для поиска открытых заявок.">
            <b-form-checkbox id="isOpenCheckbox" v-model="searchForm.isOpen">
              <div v-if="searchForm.isOpen">Да</div>
              <div v-else>Нет</div>
            </b-form-checkbox>

          </b-form-group>
        </b-col>

        <b-col sm="auto" md="auto" lg="auto">
          <b-form-group id="tidInputGroup" label="TID:" label-for="tidInput" description="Введите TID для поиска.">
            <b-form-input id="tidInput" type="text" v-model="searchForm.tid" placeholder="Введите TID">
            </b-form-input>
          </b-form-group>
        </b-col>
        <b-col sm="auto" md="auto" lg="auto">
          <b-form-group id="merchantInputGroup" label="Мерчант:" label-for="merchantInput" description="Введите Мерчант для поиска.">
            <b-form-input id="merchantInput" type="text" v-model="searchForm.merchant" placeholder="Введите мерчант">
            </b-form-input>
          </b-form-group>
        </b-col>
        <b-col sm="auto" md="auto" lg="auto" class="d-flex align-items-center">
          <b-button-group>
            <b-button type="submit" variant="primary">Поиск</b-button>
            <b-button type="reset" variant="danger">Сброс</b-button>
          </b-button-group>
        </b-col>
      </b-row>
    </b-form>
    <b-row>
      <b-col sm="6" md="6" class="my-1">
        <b-form-group horizontal label="Фильтр" class="mb-0">
          <b-input-group>
            <b-form-input v-model="filter" placeholder="Поиск" />
            <b-input-group-append>
              <b-btn :disabled="!filter" @click="filter = ''">Очистить</b-btn>
            </b-input-group-append>
          </b-input-group>
        </b-form-group>
      </b-col>
      <b-col sm="6" md="6" class="my-1">
        <b-form-group horizontal label="На странице" class="mb-0">
          <b-form-select :options="pageOptions" v-model="perPage" />
        </b-form-group>
      </b-col>
    </b-row>

    <b-table striped hover stacked="md" show-empty empty-text="Нет записей" empty-filtered-text="Записей по вашему запросу не найдено" :items="items" :fields="fields" :filter="filter" @filtered="onFiltered" :current-page="currentPage" :per-page="perPage" caption-top>

      <template slot="table-caption">
        Заявки. Найдено  {{ requestsCount }}
      </template>

      <template slot="photo" slot-scope="row">
        <!-- we use @click.stop here to prevent emitting of a "row-clicked" event  -->
        <b-button size="sm" @click.stop="row.toggleDetails" class="mr-2" >
          {{ row.detailsShowing ? "Скрыть" : "Просмотреть"}} Фото
        </b-button>
      </template>
      <template slot="row-details" slot-scope="row">
        <b-card>
          <div v-for="url in row.item.photo_urls" :key="url.id">
            <b-img-lazy :src=" url.url" center fluid-grow width="600" height="400" blank-color="#bbb" alt="img" class="my-5" />
          </div>
        </b-card>
      </template>
    </b-table>
    <b-pagination :total-rows="items.length" :per-page="perPage" v-model="currentPage" />
  </b-container>
</template>

<script>
import moment from 'moment'
import axios from 'axios'
import DateRangePicker from 'vue2-daterange-picker'
import 'vue2-daterange-picker/dist/lib/vue-daterange-picker.min.css'
//  import store from '../store'

moment.locale('ru')

export default {
  name: 'RequestPage',
  components: { DateRangePicker },
  data () {
    return {
      currentPage: 1,
      perPage: 5,
      loading: true,
      errored: false,
      searchForm: {
        tid: '',
        merchant: '',
        isOpen: false
      },
      dateRange: {
        opens: 'center',
        startDate: moment(),
        endDate: moment().add(-2, 'days'),
        ranges: {
          'Сегодня': [moment(), moment()],
          'Вчера': [moment().subtract(1, 'days'), moment().subtract(1, 'days')],
          'Последние 7 дней': [moment().subtract(6, 'days'), moment()],
          'Последние 30 дней': [moment().subtract(29, 'days'), moment()]
        },
        locale: {
          direction: 'ltr', //  direction of text
          format: 'DD.MM.YYYY', //  fomart of the dates displayed
          separator: ' - ', //  separator between the two ranges
          applyLabel: 'Принять',
          cancelLabel: 'Отмена',
          weekLabel: 'W',
          customRangeLabel: 'Выбрать',
          daysOfWeek: moment.weekdaysMin(), //  array of days - see moment documenations for details
          monthNames: moment.monthsShort(), //  array of month names - see moment documenations for details
          firstDay: 1 //  ISO first day of week - see moment documenations for details
        }
      },

      items: [],
      fields: [
        {
          key: 'sb_id',
          label: 'ID',
          sortable: true
        },
        {
          key: 'status',
          label: 'Статус',
          sortable: true
        },
        {
          key: 'photo',
          label: 'Фото'
        },
        {
          key: 'date_of_registration',
          label: 'Регистрация',
          sortable: true
        },
        {
          key: 'deadline',
          label: 'КС',
          sortable: true
        },
        {
          key: 'time_close',
          label: 'Закрытие',
          sortable: true
        },
        {
          key: 'typical_completion',
          label: 'Типовое завершение',
          sortable: true
        }
      ],
      filter: null,
      pageOptions: [5, 10, 15]
    }
  },
  mounted: function () {
    if (this.$store.state.isLogin === false) {
      this.$store.commit('logout')
      this.$router.push('login')
      return
    }

    var from = moment()
    var to = moment()
    from.add(-2, 'days')
    this.getRequests(from, to, '', '')
  },
  computed: {
    requestsCount () {
      return this.items.length
    }
  },
  methods: {
    onDateRangeUpdate: function (values) {
      this.dateRange.startDate = moment(values.startDate)
      this.dateRange.endDate = moment(values.endDate)
    },
    onFiltered: function (filteredItems) {
      this.totalRows = filteredItems.length
      this.currentPage = 1
    },
    onSearch: function (evt) {
      evt.preventDefault()
      this.getRequests(this.dateRange.startDate, this.dateRange.endDate, '', '')
    },

    onReset: function (evt) {
      evt.preventDefault()
      this.searchForm.tid = ''
      this.searchForm.merchant = ''
    },

    getRequests: function (from, to, tid, merchant) {
      from = from.startOf('day')
      var url =
        this.$root.$data.baseApiUrl + 'requests?from=' +
        from.format('YYYY-MM-DD|HH:mm:ss') +
        '&to=' +
        to.format('YYYY-MM-DD|HH:mm:ss') +
        '&tid=' +
        this.searchForm.tid +
        '&merchant=' +
        this.searchForm.merchant +
        '&is_open=' +
        this.searchForm.isOpen

      this.$store.commit('spinnerRun')
      this.items = []
      axios.get(url, {headers: {'Authorization': 'Bearer ' + this.$store.state.token.access_token}})
        .then(response => {
          this.items = response.data
        })
        .catch(error => {
          console.log(error)
          this.errored = true
          if (error.response.status !== 200) {
            this.$store.commit('logout')
            this.$router.push('login')
          }
        })
        .then(response => {
          this.loading = false
          this.$store.commit('spinnerStop')
        })
    }
  }
}

</script>



// WEBPACK FOOTER //
// src/components/RequestsPage.vue